import { DatePicker, Form } from 'antd';
import { subDays, addDays } from 'date-fns';

import { InputProps } from './TextInput';

import './style.scss';

const DateInput = (props: InputProps) => {
  const { formInput, index } = props;
  const { fieldType } = formInput;

  const isDateDisabled = (current: any) => {
    const showTomorrowDate = addDays(new Date(), 1);
    const showTodayDate = subDays(new Date(), 1);

    return !current || current.isAfter(showTomorrowDate) || current.isSameOrBefore(showTodayDate);
  };

  return (
    <Form.Item
      key={index}
      wrapperCol={{ span: 8, offset: 4 }}
      labelCol={{ span: 4 }}
      label={<div className={!formInput.required ? 'leftOffset' : ''}>{formInput.label}</div>}
      colon={formInput.required}
      labelAlign="left"
      name={formInput.name}
      rules={[
        {
          required: formInput.required,
          message: formInput.errorMsg,
        },
        ...((formInput.rules ? formInput.rules : []) as Array<any>),
      ]}
    >
      <DatePicker
        disabled={formInput.readonly}
        showTime={fieldType.showTime}
        style={{ width: '100%' }}
        format={fieldType.format}
        disabledDate={fieldType.specificDate && isDateDisabled}
      />
    </Form.Item>
  );
};

export default DateInput;
